import { SVGProps } from 'react';

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      fill="#686D7F"
      d="M12.752 1.406H1.249a.5.5 0 0 0-.43.75l3.634 6.178v3.76c0 .276.222.5.497.5h4.1a.5.5 0 0 0 .497-.5v-3.76l3.636-6.178a.5.5 0 0 0-.431-.75M8.428 11.47H5.572V9.03H8.43v2.438zm.15-3.697-.148.26H5.57l-.148-.26-3.098-5.24h9.353z"
    ></path>
  </svg>
);

export default SvgIcon;
